import {QueryClient, QueryKeyHashFunction} from '@tanstack/react-query';
import {getUserInfoFromToken} from 'presentation/utils';
import {FORTY_FIVE_MINUTES} from './constants';

declare module '@tanstack/react-query' {
	interface QueryOptions {
		excludeWalletCode?: boolean;
	}
}

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			retry: false,
			staleTime: FORTY_FIVE_MINUTES,
			queryKeyHashFn: ((queryKey: readonly unknown[]) => {
				const lastEntry = queryKey[queryKey.length - 1];
				const shouldExcludeWalletCode =
					lastEntry && typeof lastEntry === 'object' && 'excludeWalletCode' in lastEntry;

				if (shouldExcludeWalletCode) {
					const queryKeyWithoutOption = queryKey.slice(0, -1);
					return JSON.stringify(queryKeyWithoutOption);
				}

				const {cdUsuario: walletCode} = getUserInfoFromToken();
				return JSON.stringify([...queryKey, {walletCode}]);
			}) as QueryKeyHashFunction<readonly unknown[]>,
		},
	},
});
